<template>
    <img v-bind:src="imageUrl" class="img-fluid">
</template>

<script>
    export default {
        name: 'ApiImage',
        data: function () {
            return {
                baseUrl: 'https://sylius-pub.wisetiger-three.co.uk/media/cache/resolve/'
            }
        },
        props: {
            images: Array,
            preset: {
                type: String,
                default: 'sylius_shop_product_large_thumbnail'
            }
        },
        computed: {
            imageUrl: function () {
                if (this.images.length) {
                    return this.baseUrl+ this.preset + '/' +this.images[0].path
                } else {
                    return 'http://vyfhealth.com/wp-content/uploads/2015/10/yoga-placeholder1.jpg'
                }
            }
        }
    }
</script>
